import { useTranslation } from "react-i18next";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";
import ScrollReveal from "@/components/common/ScrollReveal";
import { industries } from "@/data/industries";
import { Link } from "@/lib/link";
import { ArrowRight } from "lucide-react";

export default function Industries() {
    const { t } = useTranslation();

    return (
        <>
            <SEO
                title="Industries We Serve — Hotels, Hospitals, Retail, Government | Exportfy.world"
                description="Exportfy.world serves 11 industries — hotels, hospitals, hospitality, government, corporate, schools, construction, manufacturing, retail, wholesale, and agriculture — with export-grade programs."
                path="/industries"
            />
            <PageHero
                eyebrow={t("industriesPage.hero.eyebrow")}
                title={t("industriesPage.hero.title")}
                subtitle={t("industriesPage.hero.subtitle")}
                image="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1600"
            />
            <section className="section-y">
                <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {industries.map((ind, i) => (
                        <ScrollReveal key={ind.slug} delay={i * 40}>
                            <Link to={ind.productPath || "/products"} className="group relative block rounded-2xl overflow-hidden aspect-[4/3]">
                                <img src={ind.image} alt={ind.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#061A2E]/95 via-[#061A2E]/40 to-transparent" />
                                <div className="absolute inset-x-0 bottom-0 p-6">
                                    <div className="text-white font-extrabold text-2xl">{ind.name}</div>
                                    <p className="text-white/75 text-sm mt-2 leading-relaxed">{ind.summary}</p>
                                    <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-2 text-sm font-semibold text-white/90 backdrop-blur-sm">
                                        {ind.productLabel || "Explore related products"}
                                        <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                                    </div>
                                </div>
                            </Link>
                        </ScrollReveal>
                    ))}
                </div>
            </section>
            <section className="section-y bg-[#0A2540] text-white">
                <div className="container-x flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
                    <div>
                        <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{t("industriesPage.cta.title")}</h2>
                        <p className="mt-3 text-white/70 max-w-2xl">{t("industriesPage.cta.subtitle")}</p>
                    </div>
                    <Link to="/custom-sourcing" className="inline-flex items-center gap-2 rounded-full bg-white text-[#0A2540] font-semibold px-7 py-4">{t("industriesPage.cta.button")} <ArrowRight className="w-4 h-4" /></Link>
                </div>
            </section>
        </>
    );
}
